import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import TipoPagoIvaRetOptions from '../../support/catalogos/TipoPagoIvaRetOptions';

const ImpuestosIvaForm = (props) => {
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const getRules = (data) => {
    let required = 'string';

    const { BaseRet, MontoRet, TipoPagoRet } = data;

    if (!!MontoRet || !!BaseRet || !!TipoPagoRet) {
      required = 'required';
    }

    return {
      BaseRet: [required, 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      MontoRet: [required, 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TipoPagoRet: [required, 'string', 'in:01'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(event, {
      name: 'isValidIvaRetenido',
      isValid: validator.passes(),
    });
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;

  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="Base impuesto"
          name="BaseRet"
          placeholder=""
          help=""
          rules={rules.BaseRet}
          value={data.BaseRet}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="Monto retenido"
          name="MontoRet"
          placeholder=""
          help=""
          rules={rules.MontoRet}
          value={data.MontoRet}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={3}
      >
        <FormControl
          type="select"
          label="Tipo de pago"
          name="TipoPagoRet"
          placeholder=""
          help=""
          rules={rules.TipoPagoRet}
          value={data.TipoPagoRet}
          options={TipoPagoIvaRetOptions}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

export default ImpuestosIvaForm;
